import { action } from 'satcheljs';

/**
 * Interface for the action message dispatched when onMessageReadEvent is completed.
 */
export interface OnMessageReadEventCompletedActionMessage {
    status: number;
    targetWindow: Window;
    hostItemIndex: string;
    completedContext?: OSF.EventCompletedContext;
}

/**
 * Action to be dispatched when onMessageReadEvent is completed.
 */
const onMessageReadEventCompleted: (
    status: number,
    targetWindow: Window,
    hostItemIndex: string,
    completedContext?: OSF.EventCompletedContext
) => OnMessageReadEventCompletedActionMessage = action(
    'onMessageReadEventCompleted',
    (
        status,
        targetWindow,
        hostItemIndex,
        completedContext
    ): OnMessageReadEventCompletedActionMessage => ({
        status,
        targetWindow,
        hostItemIndex,
        completedContext,
    })
);
export default onMessageReadEventCompleted;
